._media-manager-panel-preloader_kr0sd_1 {
  margin-top: 65px; }
